"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("./utils");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Analytics =
/*#__PURE__*/
function () {
  function Analytics(listeners) {
    _classCallCheck(this, Analytics);

    this.analyticsHistory = [];
    this.listeners = (0, _utils.assertlisteners)(listeners);
    this.callListener = this.callListener.bind(this);
  }

  _createClass(Analytics, [{
    key: "on",
    value: function on(eventType, callback) {
      if (typeof callback !== 'function') {
        throw new Error("Expected onClick listener to be a function, instead got type ".concat(_typeof(callback)));
      }

      if (typeof eventType !== 'string' || eventType.length < 1) {
        throw new Error("No event type is specified. (*) to listen on all events");
      }

      callback.eventType = eventType;
      this.listeners = [].concat(_toConsumableArray(this.listeners), [callback]);
    }
  }, {
    key: "callListener",
    value: function callListener(event) {
      var _ref = event || {},
          type = _ref.type,
          data = _ref.data;

      if (!type) {
        return null;
      }

      for (var i = 0; i < this.listeners.length; i++) {
        var listener = this.listeners[i];

        if (typeof listener === 'function' && (listener.eventType === type || _typeof(listener.eventType) === 'object' && listener.eventType.includes(type) || listener.eventType === '*' || typeof listener.eventType === 'undefined')) {
          var save = listener.call(null, event, this.analyticsHistory);

          if (save) {
            this.analyticsHistory = [].concat(_toConsumableArray(this.analyticsHistory), [save]);
          }
        }
      }
    }
  }, {
    key: "getHistory",
    value: function getHistory() {
      return this.analyticsHistory;
    }
  }]);

  return Analytics;
}();

exports["default"] = Analytics;